import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledRadioGroup, Fieldset } from '@components';

export interface IncomeConsistencyOptions {
  value: string;
  label: string;
}

export const IncomeConsistency = () => {
  const { t } = useTranslation('subModules/incomeConsistency');
  const fields: { [key: string]: string } = t('fields', {
    returnObjects: true,
  }) as { [key: string]: string };

  const { getValues } = useFormContext();

  const employmentStatus = getValues('employmentStatus');

  if (employmentStatus === 'FULL_TIME' || !employmentStatus) return <></>;

  return (
    <Fieldset label={t('label')} data-tf-sensitive="true" required>
      <ControlledRadioGroup
        name="incomeConsistency"
        fields={fields}
        aria-labelledby="income-consistency-radio-buttons"
        data-testid="incomeConsistencySubModule"
      />
    </Fieldset>
  );
};
